module.exports = __webpack_public_path__ + "static/media/vf_wdress_core.564805a7.svg";